export default __webpack_public_path__ + "static/media/ETC-BNB.97833428.svg";